import { processSilentRenew } from 'redux-oidc';
processSilentRenew();